import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../Context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.subtitle')}</p>
        </motion.div>

        <div className="contact-container">
          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <a href="mailto:ktgpb.info@gmail.com" className="info-card">
              <div className="info-icon">
                <i className="fa fa-envelope" aria-hidden="true"></i>
              </div>
              <div className="info-content">
                <h3>{t('contact.emailUs')}</h3>
                <span>ktgpb.info@gmail.com</span>
              </div>
            </a>

            <a href="https://www.linkedin.com/company/ktgpb/" target="_blank" rel="noopener noreferrer" className="info-card">
              <div className="info-icon">
                <i className="fa fa-linkedin" aria-hidden="true"></i>
              </div>
              <div className="info-content">
                <h3>LinkedIn</h3>
                <span>KTGPB</span>
              </div>
            </a>

            <a href="https://www.instagram.com/ktgpb/" target="_blank" rel="noopener noreferrer" className="info-card">
              <div className="info-icon">
                <i className="fa fa-instagram" aria-hidden="true"></i>
              </div>
              <div className="info-content">
                <h3>Instagram</h3>
                <span>@ktgpb</span>
              </div>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
